module.exports = __webpack_public_path__ + "static/img/icon_group.e0db507.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/icon_group.png
// module id = cOzj
// module chunks = 0